/**
 * Generates a consistent color from a unique identifier.
 *
 * Uses a hash of the UID to deterministically select a color from a predefined palette.
 * The same UID will always return the same color.
 *
 * @param uid - The unique identifier to generate a color from
 * @returns A hex color string (e.g., "#1976D2")
 *
 * @example
 * getColorFromUid('user-123') // '#7B1FA2'
 * getColorFromUid('user-123') // '#7B1FA2' (same input = same output)
 */
export function getColorFromUid(uid: string): string {
  const colors = [
    '#1976D2',
    '#388E3C',
    '#D32F2F',
    '#7B1FA2',
    '#F57C00',
    '#0288D1',
    '#689F38',
    '#FBC02D',
    '#455A64',
    '#C2185B',
    '#512DA8',
    '#0097A7',
  ]

  if (!uid || typeof uid !== 'string') {
    return colors[0]
  }

  const hash = uid
    .substring(0, 8)
    .split('')
    .reduce((acc, char) => {
      return acc + char.charCodeAt(0)
    }, 0)

  return colors[hash % colors.length]
}
